
/*
* BasciForm component is the component that handle all the GUI behaviours
* no API call here only UI
*
*/

import {
    Component,
    Output,
    EventEmitter,
    NgZone,
    ChangeDetectorRef,
    ApplicationRef,
    ViewChild,
    ElementRef
} from '@angular/core';

import { Yii } from "libraries/interfaces/Yii";
import { faTimesCircle, IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'basic-form',
    templateUrl: 'basicForm.html'
})
export class BasicFormComponent {

    @Output()
    public closeactioncall: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('freeTextInput')
    public inputElRef: ElementRef;

    // translated strings :
    public t_noResults = Yii.t('wui-shared-js', 'Aucun résultat trouvé');
    public t_seeMore = Yii.t('wui-shared-js', 'En voir plus');
    public t_close = Yii.t('wui-shared-js', 'Fermer');
    public t_createActionLabel: string = Yii.t('wui-shared-js', 'Créer');
    public t_continueActionLabel: string = Yii.t('wui-shared-js', 'Continuer');
    public t_formTitle: string = Yii.t('wui-shared-js', 'Ajouter un élément');
    public t_detail: string = Yii.t('wui-shared-js', 'Détail');
    public t_write: string = Yii.t('wui-shared-js', 'Rédiger');
    public t_titleInputPlaceholder: string = Yii.t('wui-shared-js', 'Titre');
    public t_unknownOption: string = Yii.t('wui-shared-js', 'Je ne sais pas');
    public t_displayedResult: string = Yii.t('wui-shared-js', 'résultats affichés');
    public t_exportLabel: string = Yii.t('wui-shared-js', 'Exporter');
    public t_rejectLabel: string = Yii.t('wui-shared-js', 'Rejeter');
    public permissions: any;

    public inEditionData: any = {
        'title': "",
        'categoryCode': ""
    };

    // services vars definition :
    public itemService: any;

    public iconTimesCircle: IconDefinition = faTimesCircle;
    public iconPlus: IconDefinition = faPlus;

    // private vars :
    private sectionCategoryList: any = [];

    constructor(protected ngzone: NgZone,
        protected cdref: ChangeDetectorRef,
        protected appref: ApplicationRef) {
    }

    public submitForm(): void {
        //
    }

    // component functions :

    public closeForm(): void {
        this.closeactioncall.emit(true);
    }

    public keyAction(event: any): void {
        if (event.which === 13) {
            this.submitForm();
        }
        if (event.which === 27) {
            this.closeForm();
        }
    }

}
